export default __webpack_public_path__ + "static/media/223.9b624149.png";